export default __webpack_public_path__ + "static/media/Telegram.dc4d082a.svg";